export enum ActiveTab {
    trade = 0,
    pm = 1,
    concept = 2,
}
